<template>
  <div class="hamburger">
    <div>
      <span class="line" />
      <span class="line" />
      <span class="line" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MenuButton',
  methods: {},
}
</script>

<style lang="scss" scoped>
.hamburger {
  background: #fff;
  border-right: 1px solid #eee;
  cursor: pointer;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.4s;
  .line {
    width: 18px;
    height: 2px;
    background-color: #666;
    display: block;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    &:nth-child(2) {
      margin: 4px auto;
    }
    &:last-child {
      width: 10px;
      margin-right: 8px;
    }
  }
  &.active {
    border-right-color: transparent;
  }
  &.active > div {
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    -webkit-transition-delay: 0.6s;
    -o-transition-delay: 0.6s;
    transition-delay: 0.6s;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &.active .line:nth-child(3) {
    margin: 0;
    width: 0px;
  }
  &.active .line:nth-child(1),
  &.active .line:nth-child(2) {
    -webkit-transition-delay: 0.3s;
    -o-transition-delay: 0.3s;
    transition-delay: 0.3s;
    border-radius: 0;
  }
  &.active .line:nth-child(1) {
    transform: translateY(0px);
  }
  &.active .line:nth-child(2) {
    transform: translateY(-6px) rotate(90deg);
  }
}
</style>
